import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

// Register-car modal; the form itself is owned by the map component.
@Component({
  selector: 'save-car-modal',
  templateUrl: './save-car-modal.component.html',
  styleUrls: ['./save-car-modal.component.css'],
})
export class SaveCarModalComponent {
  @Input() form: FormGroup;
  @Input() access: any;

  @Output() guideRequested = new EventEmitter<void>();
  @Output() submitted = new EventEmitter<void>();
}
